import { render, staticRenderFns } from "./valentine.vue?vue&type=template&id=03da5112&scoped=true"
import script from "./valentine.vue?vue&type=script&lang=js"
export * from "./valentine.vue?vue&type=script&lang=js"
import style0 from "./valentine.vue?vue&type=style&index=0&id=03da5112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da5112",
  null
  
)

export default component.exports